import React from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { Modal, Button, FormControl, ControlLabel } from "react-bootstrap";
import Select from "react-select";
import "react-select/dist/react-select.css";

import Dialog from "react-bootstrap-dialog";
import glamorous from "glamorous";
import Colors from "../../styles/colors";
import {
  addUser,
  updateUser,
  deleteUser,
  blockUser,
  unblockUser
} from "./UsersState";
import { ModalMode } from "./UsersView";
import { Roles, hasRole } from "../auth/authorization";

class UsersModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      confirmEmail: "",
      phoneNumber: "",
      selectedRoleId: -1,
      user: null
    };

    this.inputFieldsValid = this.inputFieldsValid.bind(this);
  }

  componentDidMount() {
    Dialog.setOptions({
      defaultOkLabel: "Yes",
      defaultCancelLabel: "No",
      primaryClassName: "btn-success"
    });
  }

  componentWillReceiveProps(nextProps) {
    const { show } = nextProps;
    const { user } = this.state;
    const { roles } = this.props;

    if (!show) {
      this.setState({
        email: "",
        confirmEmail: "",
        phoneNumber: "",
        selectedRoleId: "",
        user: null
      });
    }

    if (!_.isEqual(user, nextProps.user) && nextProps.user) {
      const role = _.head(
        _.filter(roles, { friendlyName: nextProps.user.role })
      );
      this.setState({
        email: nextProps.user.email,
        phoneNumber: "",
        selectedRoleId: role ? role._id : "",
        user: nextProps.user
      });
    }
  }

  inputFieldsValid() {
    const { email, confirmEmail, selectedRoleId } = this.state;
    const { modalMode } = this.props;

    if (modalMode === ModalMode.UPDATE) {
      return email && selectedRoleId ? true : false;
    } else {
      return this.isValidEmail(email) &&
        email === confirmEmail &&
        selectedRoleId
        ? true
        : false;
    }
  }

  isValidEmail(address) {
    var re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    return re.test(address);
  }

  getActionBtnText(modalMode) {
    switch (modalMode) {
      case ModalMode.CREATE:
        return "Create";
      case ModalMode.UPDATE:
        return "Update";
      case ModalMode.DELETE:
        return "Delete";
      case ModalMode.BLOCK:
        return "Mark Inactive";
      case ModalMode.UNBLOCK:
        return "Mark Active";
      default:
        break;
    }
  }

  getActionBtnColor(modalMode) {
    switch (modalMode) {
      case ModalMode.CREATE:
        return Colors.highlight.GREEN;
      case ModalMode.UPDATE:
        return Colors.highlight.GREEN;
      case ModalMode.DELETE:
        return Colors.highlight.RED;
      case ModalMode.BLOCK:
        return Colors.highlight.RED;
      case ModalMode.UNBLOCK:
        return Colors.highlight.GREEN;
      default:
        break;
    }
  }

  getModalTitle(modalMode) {
    switch (modalMode) {
      case ModalMode.CREATE:
        return "Add New User";
      case ModalMode.UPDATE:
        return "Edit User";
      case ModalMode.DELETE:
        return "Delete User";
      case ModalMode.BLOCK:
        return "Mark User Inactive";
      case ModalMode.UNBLOCK:
        return "Mark User Active";
      default:
        break;
    }
  }

  filterRoleTypes(roles) {
    return hasRole(Roles.ORGANIZATION_ADMIN, roles)
      ? _.filter(roles, function(r) {
          return (
            r.name === Roles.ORGANIZATION_ADMIN ||
            r.name === Roles.ORGANIZATION_USER
          );
        })
      : roles;
  }

  updateRoleName(roles) {
    roles.forEach(role => {
      switch (role.name) {
        case Roles.CARRIER_SYSTEM:
          role.friendlyName = "Carrier System";
          break;
        case Roles.FREIGHTVERIFY_ADMIN:
          role.friendlyName = "FreightVerify Admin";
          break;
        case Roles.ORGANIZATION_ADMIN:
          role.friendlyName = "Organization Admin";
          break;
        case Roles.ORGANIZATION_USER:
          role.friendlyName = "Organization User";
          break;
        case Roles.THIRD_PARTY_SYSTEM:
          role.friendlyName = "Third-Party System";
          break;
        default:
          break;
      }
    });

    return roles;
  }

  render() {
    const {
      show,
      hide,
      modalMode,
      addUser,
      updateUser,
      deleteUser,
      blockUser,
      unblockUser,
      roles
    } = this.props;
    const { email, confirmEmail, selectedRoleId, user } = this.state;

    // check if user is org admin
    let roleTypes = roles ? this.filterRoleTypes(roles) : [];
    roleTypes = roleTypes ? this.updateRoleName(roleTypes) : [];

    const _this = this;
    const disabled =
      modalMode !== ModalMode.DELETE &&
      modalMode !== ModalMode.BLOCK &&
      modalMode !== ModalMode.UNBLOCK
        ? !this.inputFieldsValid()
        : false;
    const actionBtnTxt = this.getActionBtnText(modalMode);
    const actionBtnColor = this.getActionBtnColor(modalMode);
    const modalTitle = this.getModalTitle(modalMode);

    const rolesTitle = modalMode === ModalMode.DELETE ? "" : "User Role(s)";

    return (
      <Modal show={show} onHide={() => hide()}>
        <Modal.Header
          closeButton
          style={{
            padding: "0.5em",
            color: Colors.background.DARK_BLUE,
            backgroundColor: Colors.background.LIGHT_GRAY
          }}
        >
          <Modal.Title style={{ fontWeight: "300" }}>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: Colors.background.LIGHT_GRAY }}>
          {modalMode !== ModalMode.BLOCK && modalMode !== ModalMode.UNBLOCK ? (
            <glamorous.Div>
              <glamorous.Div
                css={{
                  display: "flex",
                  flex: 1,
                  flexDirection: "row",
                  marginTop: "1em"
                }}
              >
                <glamorous.Div css={{ width: "50%", color: "#acb5be" }}>
                  <ControlLabel style={{ fontWeight: "normal" }}>
                    Email
                  </ControlLabel>
                  {modalMode === ModalMode.DELETE ||
                  modalMode === ModalMode.UPDATE ? (
                    <glamorous.P
                      css={{
                        fontWeight: 400,
                        fontStyle: "italic",
                        color: "black"
                      }}
                    >
                      <strong>{email}</strong>
                    </glamorous.P>
                  ) : (
                    <FormControl
                      style={{
                        backgroundColor: "white",
                        height: "3em",
                        boxShadow: "none"
                      }}
                      type="text"
                      value={email || ""}
                      onChange={evt =>
                        this.setState({ email: evt.target.value })
                      }
                    />
                  )}
                </glamorous.Div>

                <glamorous.Div css={{ width: "50%", color: "#acb5be" }}>
                  {modalMode === ModalMode.DELETE ||
                  modalMode === ModalMode.UPDATE ? null : (
                    <glamorous.Div>
                      <ControlLabel style={{ fontWeight: "normal" }}>
                        Confirm Email
                      </ControlLabel>
                      <FormControl
                        style={{
                          backgroundColor: "white",
                          height: "3em",
                          boxShadow: "none"
                        }}
                        type="text"
                        value={confirmEmail || ""}
                        onChange={evt =>
                          this.setState({ confirmEmail: evt.target.value })
                        }
                      />
                    </glamorous.Div>
                  )}
                </glamorous.Div>
              </glamorous.Div>

              <glamorous.Div
                css={{
                  display: "flex",
                  flex: 1,
                  flexDirection: "row",
                  marginTop: "1em"
                }}
              >
                <glamorous.Div css={{ width: "50%", color: "#acb5be" }}>
                  <ControlLabel style={{ fontWeight: "normal" }}>
                    {rolesTitle}
                  </ControlLabel>
                  {modalMode === ModalMode.DELETE ? null : (
                    <Select
                      style={{ height: "3em" }}
                      options={roleTypes.map(r => {
                        return { value: r._id, label: r.friendlyName };
                      })}
                      simpleValue
                      name="selected-state"
                      value={selectedRoleId}
                      onChange={v => this.setState({ selectedRoleId: v })}
                    />
                  )}
                </glamorous.Div>
              </glamorous.Div>
            </glamorous.Div>
          ) : (
            <glamorous.Div />
          )}
        </Modal.Body>
        <Modal.Footer style={{ backgroundColor: "#e2e2e2" }}>
          <Button
            style={{
              backgroundColor: "white",
              color: Colors.background.DARK_BLUE,
              marginRight: "0.5em"
            }}
            onClick={() => hide()}
          >
            Cancel
          </Button>
          <Button
            disabled={disabled}
            style={{
              backgroundColor: actionBtnColor,
              color: "white",
              fontWeight: "300"
            }}
            onClick={() => {
              if (modalMode === ModalMode.CREATE) {
                const payload = {
                  email: email,
                  role_id: selectedRoleId
                };
                addUser(payload);
                hide();
              } else if (modalMode === ModalMode.UPDATE) {
                const payload = {
                  role_id: selectedRoleId
                };
                updateUser(user.user_id, payload);
                hide();
              } else if (modalMode === ModalMode.DELETE) {
                _this.dialog.show({
                  body: "Are you sure you want to delete this user?",

                  actions: [
                    Dialog.CancelAction(dialog => {
                      dialog.hide();
                    }),
                    Dialog.OKAction(() => {
                      deleteUser(user);
                      hide();
                    })
                  ],
                  bsSize: "small",
                  onHide: dialog => {
                    dialog.hide();
                    console.log("closed by clicking background.");
                  }
                });
              } else if (modalMode === ModalMode.BLOCK) {
                blockUser(user);
                hide();
              } else if (modalMode === ModalMode.UNBLOCK) {
                unblockUser(user);
                hide();
              }
            }}
          >
            {actionBtnTxt}
          </Button>
          <Dialog
            ref={el => {
              this.dialog = el;
            }}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    users: state.users.data ? state.users.data.response : state.users.data
  };
}

function mapDispatchToProps(dispatch) {
  return {
    addUser: payload => dispatch(addUser(payload)),
    updateUser: (userId, payload) => dispatch(updateUser(userId, payload)),
    deleteUser: user => dispatch(deleteUser(user)),
    blockUser: user => dispatch(blockUser(user)),
    unblockUser: user => dispatch(unblockUser(user))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UsersModal);



// WEBPACK FOOTER //
// ./src/modules/users/UsersModal.js